import { memo, useMemo } from "react";

import { BillingTypeTarget } from "@/lib/gql/__generated__/graphql";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";

import { QuestionCoSleeping } from "./co-sleeping";
import { QuestionPlanDoNotCountKidsAsStock } from "./do-not-count-kids-as-stock";
import { QuestionPlanKidsPolicy } from "./kids-policy";
import { useProductPlanFormModelContext } from "../../../context";

const id = "question_plan_kidsPolicy";

export const QuestionPlanKidsPolicyRoot = memo(() => {
	const {
		viewModel: { billingTypeTarget },
	} = useProductPlanFormModelContext();

	const canShow = billingTypeTarget.value === BillingTypeTarget.Person;

	const defaultValue = useMemo(() => {
		if (billingTypeTarget.isEdited) {
			return id;
		}

		return undefined;
	}, [billingTypeTarget.isEdited]);

	return (
		canShow && (
			<Accordion type={"single"} collapsible defaultValue={defaultValue}>
				<AccordionItem value={id}>
					<AccordionTrigger>
						<p>プラン独自のキッズポリシー設定</p>
					</AccordionTrigger>
					<AccordionContent>
						<div className="flex min-h-fit flex-col gap-y-12">
							<QuestionPlanKidsPolicy />
							<QuestionCoSleeping />
							<QuestionPlanDoNotCountKidsAsStock />
						</div>
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		)
	);
});

QuestionPlanKidsPolicyRoot.displayName = "QuestionPlanKidsPolicyRoot";
